export default __webpack_public_path__ + "static/media/transmitOn.c75c0a29.svg";